import React, { useState } from 'react';
import { models } from '@vote4dance/judging-sdk';
import { ScheduleRoundsTable } from './ScheduleRoundsTable';
import { ScheduleItemEdit } from './ScheduleItemEdit';
var ScheduleItem = models.schedules.ScheduleItem;
export const ScheduleItemView = (props) => {
    const { event_id, scheduleItem, disabled } = props;
    const [visibleEdit, setVisibleEdit] = useState(false);
    return (React.createElement(React.Fragment, null,
        ScheduleItem.hasRounds(scheduleItem) &&
            React.createElement(ScheduleRoundsTable, { event_id: event_id, schedule_id: scheduleItem.schedule_id, disabled: disabled }),
        React.createElement(ScheduleItemEdit, { event_id: event_id, scheduleItem: scheduleItem, visible: visibleEdit, setVisible: setVisibleEdit, disabled: disabled })));
};
